import {
  CheckCircleIcon,
  ExclamationCircleIcon,
  InformationCircleIcon,
} from '@heroicons/react/24/outline';
import clsx from 'clsx';
import React, { createContext, useContext } from 'react';

const VARIANTS = {
  INFO: 'info',
  SUCCESS: 'success',
  WARNING: 'warning',
  ERROR: 'error',
};

const CalloutContext = createContext();

export const useCallout = () => useContext(CalloutContext);

function Callout({ children, variant, padded = true }) {
  return (
    <CalloutContext.Provider value={variant}>
      <div
        className={clsx('py-2 px-2 rounded', {
          'bg-gray-50': variant === VARIANTS.INFO,
          'bg-green-50': variant === VARIANTS.SUCCESS,
          'bg-orange-50': variant === VARIANTS.WARNING,
          'bg-red-50': variant === VARIANTS.ERROR,
          'my-4': padded,
        })}
      >
        <div className="flex gap-x-2">
          <div>
            {variant === VARIANTS.INFO ? (
              <InformationCircleIcon className="h-5 w-5 text-gray-400" />
            ) : variant === VARIANTS.SUCCESS ? (
              <CheckCircleIcon className="h-5 w-5 text-green-300" />
            ) : variant === VARIANTS.WARNING ? (
              <ExclamationCircleIcon className="h-5 w-5 text-orange-400" />
            ) : variant === VARIANTS.ERROR ? (
              <ExclamationCircleIcon className="h-5 w-5 text-red-400" />
            ) : null}
          </div>

          <div>{children}</div>
        </div>
      </div>
    </CalloutContext.Provider>
  );
}

function Heading({ children }) {
  return <h3 className={clsx('text-sm font-medium text-black')}>{children}</h3>;
}

function Content({ children }) {
  return (
    <div className={clsx('mt-1 text-sm text-gray-800', {})}>
      <p>{children}</p>
    </div>
  );
}

Callout.Heading = Heading;
Callout.Content = Content;

export default Callout;
